/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';
import { Link } from 'react-router';
import { injectIntl } from 'react-intl';
import { Panel, Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import format from 'date-fns/format';
import Editable from 'loracoms/Editable';
import RichLabel from 'loracoms/RichLabel';
import ShowIf from 'loracoms/ShowIf';
import Nvl from 'loracoms/Nvl';
import { callAPI } from 'lorautils/api';
import IntlMsg from 'lorautils/intl/IntlMsg';
import ErrorSet from 'lorautils/errors/ErrorSet';
import FreqSpectrum from '../../../FreqSpectrum';
import styles from './styles.scss';

const propTypes = {
  pushState: PropTypes.func.isRequired,
  plan: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
};

class ChannelPlanBrief extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      plan: props.plan,
      errors: new ErrorSet(),
    };
    this.intlMsg = new IntlMsg(props.intl, 'network.channelview');
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { plan } = nextProps;
    if (plan !== this.props.plan) {
      this.setState({ plan });
    }
  }

  handleSubmit() {
    const { editData: { name }, plan, errors } = this.state;
    if (_.trim(name).length !== 0) {
      callAPI({
        method: 'PUT',
        endpoint: `/lora/chplans/${plan.id}`,
        body: { name },
      }).then(() => {
        callAPI({
          endpoint: `/lora/chplans/${plan.id}`,
        }).then((resp) => {
          this.setState({ plan: resp });
        }).catch(() => {});
      }).catch(() => {});
      this.setState({ edit: false });
    } else {
      this.setState({ errors: errors.add('FE_EMPTY', 'name') });
    }
  }

  handleOnChange(d) {
    const { errors } = this.state;
    this.setState({ editData: d, errors: errors.remove('name') });
  }
  render() {
    const { pushState } = this.props;
    const {
      plan,
      edit = false,
      editData = { name: plan.name },
      errors,
    } = this.state;

    return (
      <div className={styles.chplan}>
        <Panel bsStyle="aisz-white">
          <div className={styles.band}>
            <RichLabel content={plan.band} />
          </div>
          <Row>
            <Col md={4}>
              <div className={styles.content}>
                <div className={styles.name}>
                  <Editable
                    edit={edit}
                    value={plan.name}
                    data={editData}
                    id="name"
                    onChange={d => this.handleOnChange(d)}
                    error={this.intlMsg.errorMsg(errors.get('name'))}
                    errorPlacement={'top'}
                    formatter={x => (
                      <Link onClick={() => pushState(`/network/chplans/${plan.id}`)}>
                        <Nvl val={x} />
                      </Link>
                    )}
                  />
                  <span className={styles.edit}>
                    <ShowIf if={!edit}>
                      <Link
                        onClick={() => this.setState({
                          edit: true,
                          editData: { name: plan.name },
                        })}
                      >
                        <span className="halflings halflings-pencil" />
                      </Link>
                    </ShowIf>
                    <ShowIf if={edit}>
                      <ul className="list-inline">
                        <li>
                          <Link onClick={this.handleSubmit}>
                            <span className="halflings halflings-ok text-success" />
                          </Link>
                        </li>
                        <li>
                          <Link
                            onClick={() => this.setState({
                              edit: false,
                              editData: undefined,
                              errors: errors.remove('name'),
                            })}
                          >
                            <span className="halflings halflings-remove text-warning" />
                          </Link>
                        </li>
                      </ul>
                    </ShowIf>
                  </span>
                </div>
                <div className={styles.channels}>
                  <span className={styles.label}>
                    {this.intlMsg.msg('channelnumber')}
                  </span>
                  <span className={styles.value}>
                    {plan.channels.length}
                  </span>
                </div>
                <div className={styles.createTime}>
                  {format(plan.createdAt, 'YYYY-MM-DD HH:mm:ss')}
                </div>
              </div>
            </Col>
            <Col md={8}>
              <FreqSpectrum plan={plan} />
            </Col>
          </Row>
        </Panel>
      </div>
    );
  }
}

ChannelPlanBrief.propTypes = propTypes;

export default connect(null, {
  pushState: routerActions.push,
})(injectIntl(ChannelPlanBrief));




// WEBPACK FOOTER //
// ./src/containers/Network/coms/ChannelView/coms/ChannelPlans/coms/ChannelPlanBrief/index.jsx